module.exports = __webpack_public_path__ + "static/media/CEO_profile2.58121e64.jpg";